import { Link } from "react-router-dom";
import { UserPlus } from "@phosphor-icons/react";

const PRIORITY_CLS = { Hot: "badge-hot", Normal: "badge-normal", Urgent: "badge-urgent" };
const STATUS_CLS = {
  Active: "badge-active",
  Hold: "badge-pause",
  Resumed: "badge-active",
  Pause: "badge-pause",
  Completed: "badge-completed",
  Cancelled: "badge-cancelled",
};

function CandidateRow({ candidate, employees, onAssign, canWrite }) {
  const emp = employees.find((e) => e.id === candidate.assigned_employee_id);
  return (
    <tr
      className="border-t border-slate-100 hover:bg-slate-50 transition-colors"
      data-testid={`candidate-row-${candidate.id}`}
    >
      <td className="px-4 py-3">
        <Link
          to={`/candidates/${candidate.id}`}
          className="font-medium text-slate-900 hover:text-sky-700"
        >
          {candidate.full_name}
        </Link>
        <div className="text-xs text-slate-500">{candidate.email}</div>
      </td>
      <td className="px-4 py-3 text-slate-600">{candidate.preferred_role || "—"}</td>
      <td className="px-4 py-3">
        <span className={`text-xs px-2 py-0.5 rounded-full ${PRIORITY_CLS[candidate.priority]}`}>
          {candidate.priority}
        </span>
      </td>
      <td className="px-4 py-3">
        <span className={`text-xs px-2 py-0.5 rounded-full ${STATUS_CLS[candidate.service_status]}`}>
          {candidate.service_status}
        </span>
      </td>
      <td className="px-4 py-3 text-right tabular-nums">{candidate.days_remaining}</td>
      <td className="px-4 py-3 text-slate-600">
        {emp?.name || <span className="text-slate-400">Unassigned</span>}
      </td>
      <td className="px-4 py-3 text-right">
        {canWrite && (
          <button
            onClick={() => onAssign(candidate.id)}
            data-testid={`assign-btn-${candidate.id}`}
            className="text-xs text-sky-700 hover:text-sky-900 inline-flex items-center gap-1"
          >
            <UserPlus size={14} /> Assign
          </button>
        )}
      </td>
    </tr>
  );
}

export default function CandidateList({ items, employees, canWrite, onAssign }) {
  return (
    <div className="bg-white border border-slate-200 rounded-lg overflow-hidden">
      <table className="w-full text-sm">
        <thead className="bg-slate-50 text-slate-500 uppercase text-xs tracking-widest">
          <tr>
            <th className="text-left px-4 py-3">Candidate</th>
            <th className="text-left px-4 py-3">Role</th>
            <th className="text-left px-4 py-3">Priority</th>
            <th className="text-left px-4 py-3">Status</th>
            <th className="text-right px-4 py-3">Days Left</th>
            <th className="text-left px-4 py-3">Assigned</th>
            <th className="text-right px-4 py-3">Actions</th>
          </tr>
        </thead>
        <tbody>
          {items.map((c) => (
            <CandidateRow
              key={c.id}
              candidate={c}
              employees={employees}
              onAssign={onAssign}
              canWrite={canWrite}
            />
          ))}
          {items.length === 0 && (
            <tr>
              <td colSpan={7} className="text-center text-slate-400 py-10">
                No candidates yet.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
